module.exports = __webpack_public_path__ + "img/app-abc.e3cd3ad0.png";